module.exports = __webpack_public_path__ + "img/xperio-black.912513cd.svg";